/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

import { Button, Heading, Icon } from 'sarsaparilla';

import styles from './PasswordSavedSuccess.module.scss';

interface PasswordSavedSuccessProps {
    transitionToLoginScreen: () => void;
}

export function PasswordSavedSuccess({
    transitionToLoginScreen,
}: PasswordSavedSuccessProps) {
    const [visible, setVisible] = React.useState(false);

    React.useEffect(() => {
        requestAnimationFrame(() => setVisible(true));
    }, []);

    return (
        <div className="px-sm-5 pt-sm-3 pb-sm-3">
            <div className={styles.iconRow}>
                <span className={`${styles.iconCircle} ${visible ? styles.visible : ''}`}>
                    <Icon iconName="check" />
                </span>
            </div>
            <Heading
                headingLevel={1}
                appearance="h4"
                id="modal-heading"
                className="text-center"
            >
                You’re All Set!
            </Heading>

            <p className="text-lg color-text-02 text-center mt-1 mb-4">
                You can now log in with your new password.
            </p>
            <Button size="lg" shouldFitContainer onClick={transitionToLoginScreen}>
                Log In
            </Button>
        </div>
    );
}
